import { Icon, Text, CustomLink } from 'components/common'

const Education = ({ education, isMyProfile }) => {
    return (
        <>
            {(education?.major && education?.university)
                ? (
                    <div className='education-info flexBox'>
                        <Icon className='op-hat' />
                        <Text tag={'h6'} className={'const14 education PopReg'} >
                            {education?.major} <span className='darkGrey'>at</span> {education?.university}
                        </Text>
                    </div>
                )
                : (!education?.major && !education?.university && isMyProfile)
                && (
                    <div className='education-info flexBox'>
                        <Icon className='op-hat' />
                        <Text tag={'h6'} className={'education PopReg'} >
                            <CustomLink url={`/profile/edit`}>Update education</CustomLink>
                        </Text>
                    </div>
                )}
            {(!education?.major && education?.university) && (
                <div className='education-info flexBox'>
                    <Icon className='op-hat' />
                    <Text tag={'h6'} className={'const14 education PopReg'} >
                        {education?.university}
                    </Text>
                </div>
            )}
            {(education?.major && !education?.university) && (
                <div className='education-info flexBox'>
                    <Icon className='op-hat' />
                    <Text tag={'h6'} className={'const14 education PopReg'} >
                        {education?.major}
                    </Text>
                </div>
            )}
        </>
    )
}

export default Education